import { Typography } from '@material-ui/core';
import React from 'react';

const MentionEntry = (props) => {
  const {
    mention,
    theme,
    searchValue,
    isFocused,
    selectMention,
    ...parentProps
  } = props;
  
  return (
    <div {...parentProps}>
      <div className={theme?.mentionSuggestionsEntry}>
          <Typography className={theme?.mentionSuggestionsEntryText}>
            {`${mention.name} (${mention.nickname})`}
          </Typography>
        </div>
    </div>
  )
  };

  export default MentionEntry;
